'use strict';

import Swiper from 'swiper';

/**
 * @classname Slider
 * @classdesc TOPパララックス
 */
export default class Slider {
	/**
	 * @constructor
	 * @param {jQuery} $e - 該当する jQuery オブジェクト
	 */
	constructor($e) {
		console.log('Slider.constructor');
		this._$e = $e;
		const optionId = $e.attr('data-option-id');
		this._swiper = new Swiper($e, this.getOptions(optionId));
		console.log(this._swiper);

	};


	/**
	 * クリックイベントのコールバック
	 *
	 * @memberof Slider
	 * @param {string} optionId - オプションID
	 * @return {undefined}
	 */
	getOptions(optionId) {
		console.log('Slider.getOptions');
		let options;
		switch(optionId){
			case '1':
				if($(window).width() >= 576){
					options = {
						slidesPerView: 'auto',
						navigation: {
							nextEl: '.swiper-btn-next',
							prevEl: '.swiper-btn-prev',
						},
						pagination: {
							el: '.swiper-pagination',
						},
						loop: true
					};
				}else{
					options = {
						slidesPerView: 'auto',
						navigation: {
							nextEl: '.swiper-btn-next',
							prevEl: '.swiper-btn-prev',
						},
						pagination: {
							el: '.swiper-pagination',
						},
						centeredSlides: true,
						loop: true
					};
				}
				break;
			case '2':
				options = {
					autoHeight: true,
					slidesPerView: 'auto',
					navigation: {
						nextEl: '.swiper-btn-next',
						prevEl: '.swiper-btn-prev',
					},
					pagination: {
						el: '.swiper-pagination',
					},
					centeredSlides: true,
					loop: true
				}
		}
		console.log(options);
		return options;
	};
};